import React, { useRef, useState } from 'react'
import { Row, Col, message, Spin, Form, Button } from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { useDispatch, useSelector } from 'react-redux'
import PaymentStatusModal from '../../../components/Payments/PaymentStatusModal'
import OpeningFloat from '../../Sell/CashManagement/OpeningFloat'
import DefaultQuickKeyLayout from '../../../components/SetProductLayout'
import { MAIN_SALE_SCREEN } from '../../../constants/Pages'
import Beermug from '../../../assets/images/Product-icons/beer-mug.png'
import BuzzTillLogo from '../../../assets/images/buzztill_logo_text_only.png'
import Beer from '../../../assets/images/Product-icons/beer.png'
import Bowlone from '../../../assets/images/Product-icons/bowl-one.png'
import Bowl from '../../../assets/images/Product-icons/bowl.png'
import Cakefive from '../../../assets/images/Product-icons/cake-five.png'
import Cakefour from '../../../assets/images/Product-icons/cake-four.png'
import Cakethree from '../../../assets/images/Product-icons/cake-three.png'
import Cocktail from '../../../assets/images/Product-icons/cocktail.png'
import Cup from '../../../assets/images/Product-icons/cup.png'
import Drink from '../../../assets/images/Product-icons/drink.png'
import Frenchfries from '../../../assets/images/Product-icons/french-fries.png'
import Hamburgerone from '../../../assets/images/Product-icons/hamburger-one.png'
import Hamburger from '../../../assets/images/Product-icons/hamburger.png'
import Hotpot from '../../../assets/images/Product-icons/hot-pot.png'
import DefaultImage from '../../../assets/images/Product-icons/img-upload.png'
import Juice from '../../../assets/images/Product-icons/juice.png'
import Pizza from '../../../assets/images/Product-icons/pizza.png'
import Pizza2 from '../../../assets/images/Product-icons/pizza2.png'
import {
  setCommonConfigs,
  loadSelectedReg,
  loadSelectedOutlet
} from '../../../appRedux/actions/CommonData'
import RegOpenDialog from '../../../components/RegOpenDialog'
import PaymentPanel from '../../../components/SellScreen/PaymentPanel'
import ParkedSaleModal from '../../../components/SellScreen/ParkedSaleModal'
import QuickKeys from '../../../components/SellScreen/QuickKeys'
import RightPanel from '../../../components/SellScreen/RightPanel'
import PromoPrompt from '../../../components/SellScreen/PromoPrompt'
import SaleProgressModal from '../../../components/SellScreen/SaleProgressModal'
import SearchProduct from '../../../components/SearchProduct'
import {
  FolderOpenOutlined,
  // MenuFoldOutlined,
  // MenuUnfoldOutlined
  ArrowLeftOutlined,
  DownOutlined,
  UpOutlined,
  ShopOutlined,
  IdcardOutlined,
  HistoryOutlined
} from '@ant-design/icons'

import CustomScrollbars from '../../../../src/util/CustomScrollbars'
import {
  loadSellSelectedSingleProd,
  loadIsShowCompleteSale,
  loadSalePaymentStatus,
  loadIsDiscardSale,
  loadRefundSaleStatus,
  loadShowQuickKey
} from '../../../appRedux/actions/Sell'
import {
  loadCustomerObj,
  loadIsNotesRowVisible,
  loadCurrentSalesOrderStatusID,
  loadPreventSellRunnerExecution,
  loadQuicKeyDetails,
  loadIsFolderActive,
  loadQuickKeyCount,
  loadActiveFolderData,
  loadIsPaymentPanelLoading,
  loadIsSaleCompleted,
  loadEarnedLoyalty,
  loadIsDetailLoading,
  loadIsTaxExclusive,
  loadIsPaymentPanelActionCompleteActive,
  loadIsSalePanelActive,
  loadIsAllPaid,
  loadMainQuicKeyDetails,
  loadSingleScreenPay,
  processCompleteSale,
  loadAllQuicKeyDetails
} from '../../../appRedux/actions/MainSale'
import {
  StringIsNullOrEmpty,
  isEmptyObject,
  clearAllSale,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  ApplyCustomerAccountDetails,
  EnableDisableSaleStatusesByCustomer,
  onAccLayBySaleEffects,
  clusterCalculations,
  checkIndexedParkedSale,
  discardHelperFn,
  filterUserByOutlet
} from '../../../appRedux/actions/GlobalMethods'
import {
  SellProductJsonBuilderRunner,
  SellProductJsonBuilder,
  SellPaymentCalculator,
  CalculateReceiptTemplateJson
} from '../../../appRedux/actions/SellScreenMethods'
import {
  loadQuickLayoutData,
  loadPostMainSaleDeleteDataService,
  loadPostMainSaleProductServices,
  getAllQuickLayoutDetailsData
} from '../../../appRedux/actions/SellScreenServices'
import {
  checkForDuplicateTab,
  fetchCurrentSalesOrder,
  forceUpdateIndexSales,
  getSalesOrderID,
  loadCurrentSalesOrderData,
  loadCustomerSearchData,
  loadIsSelectReg,
  loadSalePriceBooks,
  loadSalePromotions,
  loadSalesOrderDataService,
  loadSellSelectedAttributes,
  loadShowHeaderFooter,
  saleIsInProgress,
  setDiscCurrPerNote,
  toggleCollapsedSideNav
} from '../../../appRedux/actions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import DataServices from '../../../Services/DataServices'
import { isMobile } from 'react-device-detect'
import * as rdd from 'react-device-detect'
import {
  PAYMENT_SOURCES_FOR_STORES,
  SYNC_TIME_GAP
} from '../../../constants/StoreSetting'
import NumPad from '../../../components/SellScreen/NumPad'
import moment from 'moment'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../../constants/IndexDBData'
import { GetIndexDBDataByTableName } from '../../../appRedux/actions/IndexDBActions'
import { TaxExclusive } from '../../../constants/GeneralSetting'
import { CONFIG_LOGS } from '../../../constants/IndexDB_Logs'
import { SaleIndexSellAttributes } from '../../../appRedux/actions/saleIndexDB'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import { LANDSCAPE_QUICK_KEY, TAB_SIZE } from '../../../constants/ThemeSetting'
import QuickKeysModal from '../../../components/SellScreen/QuickKeysModal'
import SingleScreenCartModal from '../../../components/SellScreen/SingleScreenCartModal'
import { StandardInvoice } from '../../../components/StandardInvoice'
import { StandardThermalReceipt } from '../../../components/StandardThermalReceipt'
import { useReactToPrint } from 'react-to-print'
import InfoToPrint from '../../../components/InfoToPrint'
import OutletRegSelect from '../../../components/OutletRegSelect'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

// rdd.isMobile = false;

const MainSale = match => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const componentThermalRef = useRef()
  const componentInvoiceRef = useRef()
  const handleThermalPrint = useReactToPrint({
    content: () => componentThermalRef.current
  })
  const handleInvoicePrint = useReactToPrint({
    content: () => componentInvoiceRef.current
  })

  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')
  const [getSelectedReg, setSelectedReg] = React.useState('')
  const [outletName, setOutletName] = React.useState('')
  const [registerName, setRegisterName] = React.useState('')
  const [updatePost, setUpdatePost] = React.useState(false)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getApplyDiscountPerm, setApplyDiscountPerm] = useState(false)
  const [getAccountSalePerm, setAccountSalePerm] = useState(false)
  const [getLaySalePerm, setLaySalePerm] = useState(false)
  const [getStoreCreditPerm, setStoreCreditPerm] = useState(false)
  const [getReturnStoreCredit, setReturnStoreCredit] = useState(false)
  const [getAllowMakeSales, setAllowMakeSales] = useState(false)
  const [getPrintReceipt, setPrintReceipt] = useState(false)
  const [getPrintNoteReceipt, setPrintNoteReceipt] = useState(false)
  const [getShowDiscounts, setShowDiscounts] = useState(false)
  const [getSelectNextUser, setSelectNextUser] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)
  const [isScreenOpened, setIsScreenOpened] = useState(false)
  const [isInFreeTrial, setIsInFreeTrial] = useState(false)
  const [compReload, setCompReload] = useState(1)
  // const [showQuickKeys, setShowQuickKeys] = useState(false);
  const [getTemplateData, setTemplateData] = React.useState({})
  const [getAllLayoutsData, setAllLayoutsData] = React.useState([])
  const [availableUsers, setAvaialableUsers] = React.useState([])

  const [getCurrData, setCurrData] = React.useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  const getReduxSellSelectedSingleProd = useSelector(
    ({ Sell }) => Sell.getSellSelectedSingleProduct
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxSelectedOutletReg = useSelector(
    ({ Sell }) => Sell.openCloseSelectedOutletReg
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getReduxPaymentStatusData = useSelector(
    ({ commonConfigs }) => commonConfigs.paymentStatusData
  )
  const getReduxPaymentDone = useSelector(
    ({ Sell }) => Sell.getIsShowCompleteSale
  )
  const getStoredPromos = useSelector(({ Sell }) => Sell.salePromotions)
  const getStoredBooks = useSelector(({ Sell }) => Sell.salePriceBooks)
  const isSaleCompleted = useSelector(
    ({ MainSale }) => MainSale.isSaleCompleted
  )
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const showQuickKeys = useSelector(({ Sell }) => Sell.showQuickKeys)
  const getIsDiscardSale = useSelector(({ Sell }) => Sell.isDiscardSale)
  const getRefundSaleStatus = useSelector(({ Sell }) => Sell.refundSaleStatus)
  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )
  ////////////////////
  const isMainLoading = useSelector(({ MainSale }) => MainSale.isMainLoading)
  const getIsSalePanelActive = useSelector(
    ({ MainSale }) => MainSale.getIsSalePanelActive
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getTableDataSellTax = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellTax
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getIsStoreCreditEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsStoreCreditEnabled
  )
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )
  const isDetailLoading = useSelector(
    ({ MainSale }) => MainSale.isDetailLoading
  )
  const getPreventSellRunnerExecution = useSelector(
    ({ MainSale }) => MainSale.getPreventSellRunnerExecution
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getIsExchangeSale = useSelector(
    ({ MainSale }) => MainSale.getIsExchangeSale
  )
  const getQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getQuickKeysDetails
  )
  const getIsFolderActive = useSelector(
    ({ MainSale }) => MainSale.getIsFolderActive
  )
  const getMainQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getMainQuickKeysDetails
  )
  const getActiveFolderData = useSelector(
    ({ MainSale }) => MainSale.getActiveFolderData
  )
  const getActiveColorCode = useSelector(
    ({ MainSale }) => MainSale.getActiveColorCode
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getBasicIsPercent = useSelector(
    ({ MainSale }) => MainSale.getBasicIsPercent
  )
  const getDefaultLoyaltyAmount = useSelector(
    ({ MainSale }) => MainSale.getDefaultLoyaltyAmount
  )
  const getIsPaymentPanelActionCompleteActive = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelActionCompleteActive
  )
  const getStorePaymentTypes = useSelector(
    ({ MainSale }) => MainSale.getStorePaymentTypes
  )
  const getEarnedLoyalty = useSelector(
    ({ MainSale }) => MainSale.getEarnedLoyalty
  )
  const getAccLaybyCreditAmount = useSelector(
    ({ MainSale }) => MainSale.getAccLaybyCreditAmount
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const getDiscountPriceTotal = useSelector(
    ({ MainSale }) => MainSale.getDiscountPriceTotal
  )
  const getTableDataSellPromotion = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellPromotion
  )
  const notificationBar = useSelector(
    ({ commonConfigs }) => commonConfigs.notificationBar
  )
  const notificationHead = useSelector(
    ({ commonConfigs }) => commonConfigs.notificationHead
  )
  const notificationBGColor = useSelector(
    ({ commonConfigs }) => commonConfigs.notificationBGColor
  )
  const showHeaderFooter = useSelector(
    ({ commonConfigs }) => commonConfigs.showHeaderFooter
  )
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const getConfigSellLayout = useSelector(
    ({ commonConfigs }) => commonConfigs.getConfigSellLayout
  )
  const singleScreenForCart = useSelector(
    ({ MainSale }) => MainSale.singleScreenForCart
  )
  const getEnableAllPOSLayouts = useSelector(
    ({ commonConfigs }) => commonConfigs.getEnableAllPOSLayouts
  )
  const getAllQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getAllQuickKeysDetails
  )
  const enableTaxCode = useSelector(({ MainSale }) => MainSale.enableTaxCode)

  const getIsInProgress = useSelector(({ MainSale }) => MainSale.isInProgress)
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const formDiscPer = useSelector(({ MainSale }) => MainSale.formDiscPer)
  const formDiscCurr = useSelector(({ MainSale }) => MainSale.formDiscCurr)
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const getRefundKeys = useSelector(({ MainSale }) => MainSale.getRefundKeys)
  const formAmountToPay = useSelector(({ MainSale }) => MainSale.amountToPay)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const is_all_paid = useSelector(({ MainSale }) => MainSale.is_all_paid)
  const navCollapsed = useSelector(({ settings }) => settings.navCollapsed)
  const screen_width = useSelector(({ settings }) => settings.width)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getDataToPrint = useSelector(({ MainSale }) => MainSale.getDataToPrint)
  const cartMainClass = useSelector(({ MainSale }) => MainSale.cartMainClass)
  const getStoreUsers = useSelector(({ Sell }) => Sell.getStoreUsers)

  //for selected outlet & register, commmon Data
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      // // // // // forceUpdateIndexSales(false)
      let outlet = false
      let pbook_promo_called = false
      let reg = false
      if (getReduxSelectedStoreOutlets.id && getReduxSelectedOutletReg.id) {
        //outlet
        setSelectedOutlet(getReduxSelectedStoreOutlets.id)
        setOutletName(getReduxSelectedStoreOutlets.outlet)
        dispatch(loadSelectedOutlet(getReduxSelectedStoreOutlets.id))
        outlet = getReduxSelectedStoreOutlets.id
        loadPromo_PB(
          outlet,
          true,
          true,
          '[getReduxSelectedStoreOutlets, getReduxSelectedOutletReg] -> getReduxSelectedStoreOutlets'
        )
        pbook_promo_called = true
        //register
        setSelectedReg(getReduxSelectedOutletReg.id)
        setRegisterName(getReduxSelectedOutletReg.register)

        setPrintNoteReceipt(
          getReduxSelectedOutletReg.printNoteOnReceipt ? true : false
        )
        setPrintReceipt(getReduxSelectedOutletReg.printReceipt ? true : false)
        setSelectNextUser(
          getReduxSelectedOutletReg.selectUserForNextSale ? true : false
        )
        setShowDiscounts(
          getReduxSelectedOutletReg.showDiscountsOnReceipts ? true : false
        )

        dispatch(loadSelectedReg(getReduxSelectedOutletReg.id))
        reg = getReduxSelectedOutletReg.id
      } else {
        let selectedLocalOut = localStorage.getItem('selectedOut')
        let selectedLocalReg = localStorage.getItem('selectedReg')
        if (selectedLocalOut) {
          selectedLocalOut = JSON.parse(selectedLocalOut)
          const selOutlet = getReduxSelectedStoreOutlets.id
            ? getReduxSelectedStoreOutlets.id
            : selectedLocalOut.id
          const selOutletName = getReduxSelectedStoreOutlets.outlet
            ? getReduxSelectedStoreOutlets.outlet
            : selectedLocalOut.outlet
          setSelectedOutlet(selOutlet)
          setOutletName(selOutletName)
          dispatch(loadSelectedOutlet(selOutlet))
          outlet = selOutlet
          if (pbook_promo_called)
            loadPromo_PB(
              outlet,
              true,
              true,
              '[getReduxSelectedStoreOutlets, getReduxSelectedOutletReg] -> getReduxSelectedOutletReg'
            )
        } else {
          outlet = false
          setSelectedOutlet('')
        }

        if (selectedLocalReg) {
          selectedLocalReg = JSON.parse(selectedLocalReg)
          const selReg = getReduxSelectedOutletReg.id
            ? getReduxSelectedOutletReg.id
            : selectedLocalReg.id
          const selRegName = getReduxSelectedOutletReg.register
            ? getReduxSelectedOutletReg.register
            : selectedLocalReg.register
          setSelectedReg(selReg)
          setRegisterName(selRegName)

          setPrintNoteReceipt(
            getReduxSelectedOutletReg.printNoteOnReceipt ||
              selectedLocalReg.printNoteOnReceipt
              ? true
              : false
          )
          setPrintReceipt(
            getReduxSelectedOutletReg.printReceipt ||
              selectedLocalReg.printReceipt
              ? true
              : false
          )
          setSelectNextUser(
            getReduxSelectedOutletReg.selectUserForNextSale ||
              selectedLocalReg.selectUserForNextSale
              ? true
              : false
          )
          setShowDiscounts(
            getReduxSelectedOutletReg.showDiscountsOnReceipts ||
              selectedLocalReg.showDiscountsOnReceipts
              ? true
              : false
          )

          dispatch(loadSelectedReg(selReg))
          reg = selReg
        } else {
          reg = false
          setSelectedReg('')
          setPrintNoteReceipt(false)
          setPrintReceipt(false)
          setSelectNextUser(false)
          setShowDiscounts(false)
        }
      }

      //if out or reg not selected
      if (!outlet || !reg) {
        dispatch(loadIsSelectReg(true))
      }

      if (getStoreUsers && getStoreUsers.length > 0 && outlet) {
        const userList = []
        getStoreUsers.map((user, key) => {
          const userOutlets = user.userOutlets
          if (userOutlets && userOutlets.length > 0) {
            if (
              filterUserByOutlet(user.userOutlets, getDecryptID(outlet), {}, -1)
            ) {
              userList.push(user)
            }
          }
        })
        if (userList && userList.length > 0) {
          setAvaialableUsers(userList)
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxSelectedStoreOutlets, getReduxSelectedOutletReg, getStoreUsers])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSelectedOutlet) {
        if (getStoredPromos && getStoredPromos.length == 0) {
          loadPromo_PB(
            getSelectedOutlet,
            false,
            true,
            'isOnline --> getStoredPromos'
          )
        }

        if (getStoredBooks && getStoredBooks.length == 0) {
          loadPromo_PB(
            getSelectedOutlet,
            true,
            false,
            'isOnline --> getStoredBooks'
          )
        }
      }

      if (!isOnline) {
        fetchIndexedTaxExc()
        fetchCommonConfigs()
        getQuickKeyLayoutsData()
        getAllQuickKeyLayoutsData()
      }
    }

    return () => {
      mounted = false
    }
  }, [isOnline])

  function loadPromo_PB (outlet, pb, promo, from) {
    if (pb) {
      dispatch(loadSalePriceBooks(outlet, isOnline))
    }
    if (promo) {
      dispatch(loadSalePromotions(outlet, isOnline))
    }
  }

  React.useEffect(() => {
    let mounted = true
    let eventAdded = false
    if (mounted) {
      checkSaleInProgress()
      checkExpiresOn()
      getAllQuickLayoutDetailsData(dispatch)
      const isCartOpened = localStorage.getItem('cartOpened')
      if (isCartOpened && isCartOpened == '1') {
        // Sell Screen is opened, Redirect to a different page or display message
        setIsScreenOpened(true)
      } else {
        // Store a flag in local storage to indicate this tab is open
        setIsScreenOpened(false)
        localStorage.setItem('cartOpened', '1')
        window.addEventListener('beforeunload', handleCartUnload)
        eventAdded = true
      }
    }

    // Clean up the local storage when the component unmounts or the tab is closed
    return () => {
      if (eventAdded) {
        window.removeEventListener('beforeunload', handleCartUnload)
      }
      localStorage.removeItem('cartOpened')
    }
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      let body = {
        QuickKeyLayoutID: '0&&_85e4-5adf-45c3-a667-c10cfa61c3cesalis',
        OutletID: getSelectedOutlet,
        RegisterID: getSelectedReg
      }
      if (getSelectedOutlet != '' && getSelectedReg != '') {
        dispatch(loadQuickLayoutData(body, mounted)) // , getIsFolderActive
      }
      dispatch(setCommonConfigs(MAIN_SALE_SCREEN))
    }
    return () => {
      mounted = false
    }
  }, [getSelectedReg])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    let selectedProduct = getReduxSellSelectedSingleProd

    if (mounted) {
      dispatch(loadPreventSellRunnerExecution(true))
      if (!isEmptyObject(selectedProduct)) {
        // let formDiscountPrice =
        //   form.getFieldValue("disCurrency") != undefined
        //     ? form.getFieldValue("disCurrency")
        //     : 0;
        // let formDiscountPercentage =
        //   form.getFieldValue("disPercent") != undefined
        //     ? form.getFieldValue("disPercent")
        //     : 0;
        // let formSellNotes =
        //   form.getFieldValue("SellNotes") != undefined
        //     ? form.getFieldValue("SellNotes")
        //     : "";
        selectedProduct.isNewProd = true // for adding while performing reference promo -- certain
        selectedProduct.displayQuantity = 1
        let prodsfiddler = getReduxSaleProductJsonData
        const productsClone = SellProductJsonBuilder(
          selectedProduct,
          undefined,
          '',
          getCustomerSearchData,
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'getReduxSellSelectedSingleProd-dependency',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            prodsfiddler.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = prodsfiddler.indexOf(
              prodsfiddler.filter(a => a.key == productsClone.key)[0]
            )
            prodsfiddler[index] = productsClone
          } else {
            prodsfiddler = prodsfiddler.concat(productsClone)
          }
        }
        clusterCalculations(
          prodsfiddler,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getCustomerSearchData,
          getIsRefundSale,
          getDefaultDecimalPlaces,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          getStoredPromos,
          getIsTaxExclusive,
          false,
          getSavings,
          sellSelAttributes
        )
        dispatch(loadSellSelectedSingleProd({}))
      }
    }
    return () => (mounted = false)
  }, [getReduxSellSelectedSingleProd])

  React.useEffect(() => {
    let mounted = true
    let selectedSaleOrderData = []

    if (mounted) {
      if (getPreventSellRunnerExecution == false) {
        selectedSaleOrderData = getCurrentSalesOrderData
        if (!isEmptyObject(selectedSaleOrderData)) {
          const statusID = selectedSaleOrderData.e_SalesOrderStatusID
            ? selectedSaleOrderData.e_SalesOrderStatusID
            : selectedSaleOrderData.sSalesOrderStatusID
          dispatch(loadCurrentSalesOrderStatusID(statusID))
          SellProductJsonBuilderRunner(
            selectedSaleOrderData,
            getSelectedOutlet,
            getSelectedReg,
            getBasicIsPercent,
            getCustomerSearchData,
            getIsRefundSale,
            getDefaultDecimalPlaces,
            getCurrentSalesOrderData,
            statusID, // getCurrentSalesOrderStatusID,
            formDiscCurr,
            formDiscPer,
            formSellNote,
            getReduxSaleProductJsonData,
            getStoredBooks,
            getIsLoyaltyEnabled,
            getDefaultLoyaltyAmount,
            getIsTaxExclusive,
            getStoredPromos,
            getRefundKeys,
            getSalePayments,
            dispatch,
            getSavings,
            sellSelAttributes
          )
        } else {
          let localSalesOrderID = getSalesOrderID()
          let localParentSalesOrderID =
            localStorage.getItem('parentOrderGuidID')

          if (!StringIsNullOrEmpty(localSalesOrderID)) {
            let body = {
              OutletID: '',
              SalesOrderID: localSalesOrderID,
              SalesOrderStatusID: '',
              CustomerID: '',
              UserID: '',
              CurrentPageNo: 1,
              PageSize: 10,
              isRefund: false
            }
            dispatch(
              loadSalesOrderDataService(
                body,
                getCurrentSalesOrderData,
                getSalesOrderStatuses,
                getIsInProgress,
                false
              )
            )
          } else if (
            localParentSalesOrderID != undefined &&
            !StringIsNullOrEmpty(localParentSalesOrderID)
          ) {
            if (getIsRefundSale && getIsRefundSale == 0) {
              let body = {
                OutletID: '',
                SalesOrderID: localParentSalesOrderID,
                SalesOrderStatusID: '',
                CustomerID: '',
                UserID: '',
                CurrentPageNo: 1,
                PageSize: 10,
                isRefund: true
              }
              dispatch(
                loadSalesOrderDataService(
                  body,
                  getCurrentSalesOrderData,
                  getSalesOrderStatuses,
                  getIsInProgress,
                  false
                )
              )
            }
          } else {
            if (!isEmptyObject(selectedSaleOrderData)) {
              SellProductJsonBuilderRunner(
                selectedSaleOrderData,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getCustomerSearchData,
                getIsRefundSale,
                getDefaultDecimalPlaces,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscCurr,
                formDiscPer,
                formSellNote,
                getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getRefundKeys,
                getSalePayments,
                dispatch,
                getSavings,
                sellSelAttributes
              )
            }
          }
        }
      } else {
        // setPreventSellRunnerExecution(false); //this is for not execute sell runner when click on product , set currentSalesOrderData on redux if change occur function will execute again
        // dispatch(loadPreventSellRunnerExecution(false));
      }
    }
    return () => (mounted = false)
  }, [getCurrentSalesOrderData])

  React.useEffect(() => {
    let mounted = true
    let selectedCustomer = getCustomerSearchData

    if (mounted) {
      dispatch(loadCustomerObj(selectedCustomer))
      EnableDisableSaleStatusesByCustomer(
        dispatch,
        selectedCustomer,
        getSalesOrderStatuses,
        getLaySalePerm,
        getAccountSalePerm,
        getIsRefundSale,
        getCurrentSalesOrderStatusID
      )

      ApplyCustomerAccountDetails(
        dispatch,
        selectedCustomer,
        getStorePaymentTypes,
        getDefaultDecimalPlaces,
        getIsRefundSale,
        getReturnStoreCredit,
        getIsLoyaltyEnabled,
        getIsStoreCreditEnabled
      )
      let items = getReduxSaleProductJsonData
      if (isSaleCompleted) {
        dispatch(loadIsSaleCompleted(false))
      } else {
        if (items && items.length > 0) {
          if (!getIsPaymentPanelActionCompleteActive) {
            dispatch(loadIsPaymentPanelLoading(true))
            let prodsXX = getReduxSaleProductJsonData
            items.map(item => {
              //NOTE: there is need to call again the prod builder method for working properly of removing the customer (entire sale off scenario where ref work for the whole sale)
              const productsClone = SellProductJsonBuilder(
                item,
                undefined,
                '',
                getCustomerSearchData,
                getReduxSaleProductJsonData,
                getStoredBooks,
                getIsLoyaltyEnabled,
                getDefaultLoyaltyAmount,
                getIsTaxExclusive,
                getStoredPromos,
                getDefaultDecimalPlaces,
                getSelectedOutlet,
                getSelectedReg,
                getBasicIsPercent,
                getIsRefundSale,
                getCurrentSalesOrderData,
                getCurrentSalesOrderStatusID,
                formDiscCurr,
                formDiscPer,
                formSellNote,
                getRefundKeys,
                getSalePayments,
                dispatch,
                false,
                getSavings,
                'getCustomerSearchData-dependency',
                false,
                sellSelAttributes
              )
              if (productsClone && !isEmptyObject(productsClone)) {
                if (
                  productsClone.key &&
                  prodsXX.filter(a => a.key === productsClone.key)[0]
                ) {
                  let index = prodsXX.indexOf(
                    prodsXX.filter(a => a.key == productsClone.key)[0]
                  )
                  prodsXX[index] = productsClone
                } else {
                  prodsXX = prodsXX.concat(productsClone)
                }
              }
            })
            clusterCalculations(
              prodsXX,
              getSelectedOutlet,
              getSelectedReg,
              getBasicIsPercent,
              getCustomerSearchData,
              getIsRefundSale,
              getDefaultDecimalPlaces,
              getCurrentSalesOrderData,
              getCurrentSalesOrderStatusID,
              formDiscCurr,
              formDiscPer,
              formSellNote,
              getRefundKeys,
              getSalePayments,
              dispatch,
              getStoredPromos,
              getIsTaxExclusive,
              false,
              getSavings,
              sellSelAttributes
            )
          }
          if (!getIsSalePanelActive) {
            setUpdatePost(true)
          }
        }
      }

      // console.log("XXX-YYY-ZZZ--CUSTOMER", JSON.stringify(getCustomerSearchData))
      // console.log("XXX-YYY-ZZZ--PROMO", JSON.stringify(getStoredPromos))
    }
    return () => (mounted = false)
  }, [getCustomerSearchData])

  React.useEffect(() => {
    let mounted = true
    if (getReduxPaymentDone && mounted) {
      let data = getReduxPaymentStatusData
      SellPaymentCalculator(
        data,
        getSaleOrderJson,
        getDefaultDecimalPlaces,
        getSalePayments,
        getCurrentSalesOrderData,
        getCustomerSearchData,
        getTableDataSellTax,
        getIsRefundSale,
        getIsExchangeSale,
        getCurrentSalesOrderStatusID,
        dispatch,
        getReduxStoreInfo,
        getDiscountPriceTotal,
        getTableDataSellPromotion,
        getSavings,
        getIsTaxExclusive,
        sellSelAttributes,
        getEarnedLoyalty,
        getPrintReceipt,
        enableTaxCode
      )
      dispatch(loadIsShowCompleteSale(false))
      dispatch(loadSalePaymentStatus(false)) // this is for the stopping loop on paymentTypesModal
      localStorage.setItem('statusresponse', '') // this is for the stopping loop on paymentTypesModal
      const bodccy = localStorage.getItem('gatewaypost')
        ? JSON.parse(localStorage.getItem('gatewaypost'))
        : {}
      if (bodccy && !isEmptyObject(bodccy)) {
        // posting in store db
        if (
          bodccy &&
          bodccy.SourcePay &&
          (getDecryptID(bodccy.SourcePay) == PAYMENT_SOURCES_FOR_STORES.apco ||
            getDecryptID(bodccy.SourcePay) ==
              PAYMENT_SOURCES_FOR_STORES.paypal ||
            getDecryptID(bodccy.SourcePay) ==
              PAYMENT_SOURCES_FOR_STORES.trustly)
        ) {
          postForOnlineGateway(bodccy)
        }
        const body = localStorage.setItem('gatewaypost', '')
      }
    }
    return () => (mounted = false)
  }, [getReduxPaymentDone])

  React.useEffect(() => {
    let mounted = true
    const isDiscardSale = getIsDiscardSale
    if (mounted) {
      if (isDiscardSale) {
        let saleInfo = getSaleOrderJson
        const orderID = getSalesOrderID()
        const parentSalesOrderID = localStorage.getItem('parentOrderGuidID')
        const isParent = parentSalesOrderID && parentSalesOrderID != ''
        const isPark =
          saleInfo &&
          saleInfo.E_SalesOrderStatusID &&
          getDecryptID(saleInfo.E_SalesOrderStatusID) ==
            getDecryptID(fetchCurrentSalesOrder('Parked'))

        if (isPark) {
          // SINCE PARK SALE CAN BE TOTALLY DEPENDS ON OFFLINE SALES
          checkIndexedParkedSale(
            orderID,
            getCurrentSalesOrderStatusID,
            parentSalesOrderID,
            isParent,
            isPark,
            getSelectedReg,
            getSelectedOutlet,
            saleInfo,
            getDeletedProds,
            form,
            isDiscardSale,
            dispatch
          )
        } else {
          discardHelperFn(
            orderID,
            getCurrentSalesOrderStatusID,
            parentSalesOrderID,
            isParent,
            isPark,
            getSelectedReg,
            getSelectedOutlet,
            saleInfo,
            getDeletedProds,
            form,
            isDiscardSale,
            dispatch
          )
        }

        dispatch(loadIsDiscardSale(false))
      }
    }

    return () => (mounted = false)
  }, [getIsDiscardSale])

  React.useEffect(() => {
    let mounted = true
    // let refundStatus = getRefundSaleStatus;
    //0 = Not Refund, 1 = Refund Allow, 2 = Already Refunded

    if (mounted) {
      if (getRefundSaleStatus && getRefundSaleStatus == 1) {
        let localSalesOrderID = localStorage.getItem('parentOrderGuidID')
        if (localSalesOrderID && !StringIsNullOrEmpty(localSalesOrderID)) {
          let outletID = getSelectedOutlet
          let body = {
            OutletID: outletID,
            SalesOrderID: localSalesOrderID,
            //SalesOrderStatusID: AllStatus.filter((a) => a.value == "completed")[0].id,
            CustomerID: '',
            UserID: '',
            CurrentPageNo: 1,
            PageSize: 10,
            isRefund: true
          }
          dispatch(
            loadSalesOrderDataService(
              body,
              getCurrentSalesOrderData,
              getSalesOrderStatuses,
              getIsInProgress,
              true
            )
          )
        }
      } else if (getRefundSaleStatus == 2) {
        message.info('This sale has already been completed.')
        dispatch(loadRefundSaleStatus(0))
      }
    }
    return () => (mounted = false)
  }, [getRefundSaleStatus])

  React.useEffect(() => {
    let mounted = true
    if (mounted && updatePost) {
      setUpdatePost(false)
      getSaleOrderJson.BehaviorName = 3 //for update
      if (
        getCustomerSearchData &&
        !isEmptyObject(getCustomerSearchData) &&
        getCustomerSearchData.customerSId
      ) {
        if (getIsPaymentPanelActionCompleteActive) {
          getSaleOrderJson.E_CustomerID = getCustomerSearchData.customerSId
          getSaleOrderJson.UpdateCusSaleCompleted = true
        }
      }
      let body = getSaleOrderJson
      body.Products.map(q => {
        q.BehaviorName = 3
      })
      const cashRegPay = localStorage.getItem('cashManageID')
      if (cashRegPay && cashRegPay != '') {
        body.CashRegPaymentID = cashRegPay
        dispatch(
          loadPostMainSaleProductServices(
            body,
            getSalesOrderStatuses,
            getCurrentSalesOrderData,
            getIsPaymentPanelActionCompleteActive,
            false,
            false,
            true,
            getReduxSalePaymentData,
            sellSelAttributes,
            getReduxSaleProductJsonData
          )
        )
      } else {
        message.warn('Kindly recheck register is open & selected', 4)
      }
    }
    return () => (mounted = false)
  }, [updatePost])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      EnableDisableSaleStatusesByCustomer(
        dispatch,
        getCustomerSearchData,
        getSalesOrderStatuses,
        getLaySalePerm,
        getAccountSalePerm,
        getIsRefundSale,
        getCurrentSalesOrderStatusID
      )
    }
    return () => (mounted = false)
  }, [getAccountSalePerm, getLaySalePerm])

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    // // check for Navigation Timing API support
    // let data=window.performance.getEntriesByType("navigation")[0].type;
    // if (window.performance) {
    //   console.info('window.performance works fine on this browser')
    // }
    // console.info(performance.navigation.type)
    // if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
    //   performance.navigation.type = 0
    //   console.info('This page is reloaded')
    // } else {
    //   console.info('This page is not reloaded')
    // }
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted && is_all_paid && is_all_paid == 1) {
      dispatch(loadIsPaymentPanelLoading(true))
      CalculateReceiptTemplateJson(
        getSaleOrderJson,
        getCurrentSalesOrderData,
        getCustomerSearchData,
        getTableDataSellTax,
        dispatch,
        getReduxStoreInfo,
        getDefaultDecimalPlaces,
        getDiscountPriceTotal,
        getSalePayments,
        '',
        getTableDataSellPromotion,
        getIsRefundSale,
        getSavings,
        getIsTaxExclusive,
        sellSelAttributes,
        getEarnedLoyalty,
        'main sale --> isAllPaid -> useEffect',
        enableTaxCode
      )
      if (singleScreenForCart) dispatch(loadSingleScreenPay(true))
      else dispatch(loadIsSalePanelActive(false))
      dispatch(loadIsPaymentPanelActionCompleteActive(true, 'is_all_paid'))
      dispatch(loadIsAllPaid(0))
      dispatch(loadIsPaymentPanelLoading(false))
    }
    return () => (mounted = false)
  }, [is_all_paid])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const indexKey = localStorage.getItem('index_key')
      if (
        indexKey &&
        getSaleOrderJson &&
        getSaleOrderJson.attribProps &&
        sellSelAttributes &&
        sellSelAttributes.length != getSaleOrderJson.attribProps.length
      ) {
        SaleIndexSellAttributes(
          indexKey,
          sellSelAttributes,
          dispatch,
          getSaleOrderJson
        )
      }
    }

    return () => (mounted = false)
  }, [sellSelAttributes])

  React.useEffect(() => {
    let mounted = true
    if (mounted && !checkIsWeb().exist) {
      if (getIsSalePanelActive)
        postDataToApp(PostAppTypes.PAGE_HEADER, 'tab.sell.header')
      else postDataToApp(PostAppTypes.PAGE_HEADER, 'tab.sell.header.started')
    }

    return () => (mounted = false)
  }, [getIsSalePanelActive])

  React.useEffect(() => {
    let mounted = true
    if (
      mounted &&
      getIsPaymentPanelActionCompleteActive &&
      singleScreenForCart
    ) {
      setTimeout(() => {
        processCompleteSale(
          sellActionLog,
          getCurrentSalesOrderStatusID,
          getAccLaybyCreditAmount,
          getSelectedOutlet,
          getSavings,
          getSaleOrderJson,
          isOnline,
          getPrintReceipt,
          form,
          dispatch
        )
      }, 2000)
    }

    return () => {
      mounted = false
    }
  }, [getIsPaymentPanelActionCompleteActive])

  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      if (
        getAllQuickKeysDetails.quickKeyLayouts &&
        getAllQuickKeysDetails.quickKeyLayouts.length > 0
      ) {
        let quicKKeyLayoutID = ''
        let outletID = getDecryptID(getSelectedOutlet)
        let registerID = getDecryptID(getSelectedReg)
        let registerQuickKeys = getAllQuickKeysDetails.registerQuickKeys
        if (registerQuickKeys) {
          let registerQuickKey = registerQuickKeys.filter(
            x =>
              getDecryptID(x.outletID) == outletID &&
              getDecryptID(x.registerID) == registerID
          )
          if (registerQuickKey) {
            quicKKeyLayoutID = registerQuickKey[0]?.quickKeyLayoutID
          }
        }
        if (quicKKeyLayoutID) {
          quicKKeyLayoutID = getDecryptID(quicKKeyLayoutID)
          let updatedQuickKeys =
            getAllQuickKeysDetails &&
            getAllQuickKeysDetails.quickKeyLayouts.map(x => ({
              ...x,
              currentlyActive:
                getDecryptID(x.quicKKeyLayoutID) == quicKKeyLayoutID
            }))
          const activeLayout = updatedQuickKeys.find(x => x.currentlyActive)
          if (activeLayout) {
            updatedQuickKeys = updatedQuickKeys.filter(x => !x.currentlyActive)
            updatedQuickKeys.unshift(activeLayout)
          }

          setAllLayoutsData(updatedQuickKeys.filter(x => x.isActive))

          const updatedQuickKeysDetails =
            getAllQuickKeysDetails &&
            getAllQuickKeysDetails.quickKeyLayoutDetails.filter(
              x => getDecryptID(x.quickKeyLayoutID) == quicKKeyLayoutID
            )
          dispatch(loadMainQuicKeyDetails(updatedQuickKeysDetails))
          dispatch(loadQuicKeyDetails(updatedQuickKeysDetails))
        }
      }
    }
    return () => {
      mounted = false
    }
  }, [getAllQuickKeysDetails, getSelectedReg])

  function dateDiff (first, second) {
    return Math.round((second - first) / (1000 * 60 * 60 * 24))
  }

  function checkExpiresOn () {
    const expiresOn = localStorage.getItem('subscriptionExpiresOn')
    const subEndsOn = moment(expiresOn)
    const currDate = moment()
    const daysLeft = dateDiff(currDate, subEndsOn)
    // console.log('subscription days left: '+ daysLeft);
    if (daysLeft <= 14) {
      setIsInFreeTrial(true)
    } else {
      setIsInFreeTrial(false)
    }
  }

  // React.useEffect(() => {
  //   const handleBeforeUnload = event => {
  //     event.preventDefault() // Modern browsers require this to display a custom message
  //     event.returnValue = '' // This is the message shown to the user when they attempt to refresh/close the page

  //     // Perform any necessary actions, such as saving data to IndexedDB
  //     // before the page is unloaded
  //   }

  //   window.addEventListener('beforeunload', handleBeforeUnload)

  //   return () => {
  //     // Clean up the event listener when the component unmounts
  //     window.removeEventListener('beforeunload', handleBeforeUnload)
  //   }
  // }, [])

  function checkSaleInProgress () {
    const indexKey = localStorage.getItem('index_key')
    if (indexKey) {
      dispatch(loadIsDetailLoading(true))
      const data = GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        INDEX_DB_TABLES.SALES
      )
      data
        .then(e => {
          if (e && e.length > 0) {
            const saleExist = e.filter(er => er.indexKey == indexKey)
            if (saleExist && saleExist.length > 0) {
              setTimeout(() => {
                loadSaleFromIndexDB(saleExist)
              }, 1000)
            } else dispatch(loadIsDetailLoading(false))
          } else {
            console.error(
              'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.SALES -->',
              e
            )
          }
        })
        .catch(e => {
          dispatch(loadIsDetailLoading(false))
          console.log('INDEX_DB -> checkSaleInProgress -->', e)
        })
    }
  }

  function fetchIndexedTaxExc () {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.STORECONFIGURATIONS
    )
    data
      .then(e => {
        let isExc = true
        if (e && e.length > 0) {
          isExc =
            e.filter(q => q.key == TaxExclusive).length > 0 &&
            e.filter(q => q.key == TaxExclusive)[0].value.toLowerCase() ==
              'true'
              ? true
              : false
          dispatch(loadIsTaxExclusive(isExc))
        } else {
          console.error(
            'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.STORECONFIGURATIONS -->',
            e
          )
        }
      })
      .catch(e => {
        console.log(
          'INDEX_DB -> fetchIndexedTaxExc, index api call STORECONFIGURATIONS -->',
          e
        )
      })
  }

  function fetchCommonConfigs () {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.CONFIGDATA
    )
    data
      .then(e => {
        if (e && e.length > 0) {
          const dataExist = e.filter(
            er => er.config_key == CONFIG_LOGS.COMMON_CONFIG
          )
          if (dataExist && dataExist.length > 0 && dataExist[0].data) {
            const res = JSON.parse(dataExist[0].data)
            dispatch(setCommonConfigs(false, res))
          }
        } else {
          console.error(
            'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
            e
          )
        }
      })
      .catch(e => {
        console.error('INDEX_DB_CONFIGS_ERROR -> getTemplatesFromIndex -->', e)
      })
  }

  function getQuickKeyLayoutsData () {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.CONFIGDATA
    )
    data
      .then(e => {
        if (e && e.length > 0) {
          const dataExist = e.filter(
            er => er.config_key == CONFIG_LOGS.QUICK_KEYS
          )
          if (dataExist && dataExist.length > 0 && dataExist[0].data) {
            const quickKeyFormData = JSON.parse(dataExist[0].data)
            dispatch(loadMainQuicKeyDetails(quickKeyFormData))
            // if (!getIsFolderActive)
            //   dispatch(loadQuicKeyDetails(quickKeyFormData))
            dispatch(loadQuicKeyDetails(quickKeyFormData))
          }
        } else {
          console.error(
            'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
            e
          )
        }
      })
      .catch(e => {
        console.error('INDEX_DB_CONFIGS_ERROR -> getQuickKeyLayoutsData -->', e)
      })
  }
  function getAllQuickKeyLayoutsData () {
    const data = GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.CONFIGDATA
    )
    data
      .then(e => {
        if (e && e.length > 0) {
          const dataExist = e.filter(
            er => er.config_key == CONFIG_LOGS.ALL_QUICK_KEYS
          )
          if (dataExist && dataExist.length > 0 && dataExist[0].data) {
            const detailsData = JSON.parse(dataExist[0].data)
            dispatch(loadAllQuicKeyDetails(detailsData))
          }
        } else {
          console.error(
            'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
            e
          )
        }
      })
      .catch(e => {
        console.error(
          'INDEX_DB_CONFIGS_ERROR -> getAllQuickKeyLayoutsData -->',
          e
        )
      })
  }

  const handleCartUnload = () => {
    if (!isScreenOpened) {
      localStorage.removeItem('cartOpened')
    }
  }

  function loadSaleFromIndexDB (response) {
    if (response && response.length > 0) {
      dispatch(loadIsDetailLoading(true))
      clearAllSale(false, dispatch, false)
      //setting sell attributes
      let sellAttribs = []
      if (response[0].sellAttributes && response[0].sellAttributes.length > 0) {
        sellAttribs = response[0].sellAttributes
      }
      dispatch(loadSellSelectedAttributes(sellAttribs))
      //marking to identify that the prods coming first time from backend
      if (response[0].products && response[0].products.length > 0) {
        response[0].products.map(a => (a.firstTime = true))
      }
      let saleOrderData = response[0]
      let customer = {}
      dispatch(loadIsPaymentPanelLoading(false))
      // set to false because the scenario is for page refresh and fetch the sale in progress sale --> check if there is in progress sale
      if (false) {
        // !isEmptyObject(getCurrentSalesOrderData)
        saleIsInProgress(dispatch, saleOrderData)
      } else {
        // for whole sale disc & note
        setDiscCurrPerNote(saleOrderData, dispatch)
        // for customer
        if (
          saleOrderData.customer &&
          saleOrderData.customer.length > 0 &&
          saleOrderData.customer[0].customerFirstName
        ) {
          customer = saleOrderData.customer[0]
          const firstLetter = customer.customerFirstName
            ? customer.customerFirstName.charAt(0)
            : 'x'
          const secondLetter = customer.customerLastName
            ? customer.customerLastName.charAt(0)
            : 'y'
          const lettersName =
            firstLetter.toUpperCase() + secondLetter.toUpperCase()
          customer.letterName = lettersName
        }

        dispatch(loadPreventSellRunnerExecution(false))
        dispatch(loadCurrentSalesOrderData(saleOrderData))

        if (customer && !isEmptyObject(customer)) {
          dispatch(loadCustomerSearchData(customer))
        }
      }
      dispatch(loadIsDetailLoading(false))
    } else dispatch(loadIsDetailLoading(false))
  }

  function handleWindowSizeChange () {
    setWidth(window.innerWidth)
  }

  // React.useEffect(() => {
  //   const initialValue = document.body.style.zoom;

  //   // Change zoom level on mount
  //   document.body.style.zoom = "100%";

  //   return () => {
  //     // Restore default value
  //     document.body.style.zoom = initialValue;
  //   };
  // }, []);
  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setAllowMakeSales(true)
      // setIsDisableCreate(false);
    } else {
      setAllowMakeSales(false)
      // setIsDisableCreate(true);
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
    //permissions
    if (rpData.applyDiscount) {
      setApplyDiscountPerm(true)
    } else {
      setApplyDiscountPerm(false)
    }
    if (rpData.laybySale) {
      setLaySalePerm(true)
    } else {
      setLaySalePerm(false)
    }
    if (rpData.manualStoreCredit) {
      setStoreCreditPerm(true)
    } else {
      setStoreCreditPerm(false)
    }
    if (rpData.accountSale) {
      setAccountSalePerm(true)
    } else {
      setAccountSalePerm(false)
    }
    if (rpData.returnSaleStoreCredit) {
      setReturnStoreCredit(true)
    } else {
      setReturnStoreCredit(false)
    }
    // if (rpData.makeSales) {
    //   setAllowMakeSales(true);
    // } else {
    //   setAllowMakeSales(false);
    // }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    // setIsAllowRead(false);
    setAllowMakeSales(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
    setApplyDiscountPerm(false)
    setAccountSalePerm(false)
    setLaySalePerm(false)
    setStoreCreditPerm(false)
  }

  async function postForOnlineGateway (body) {
    const cashRegPay = localStorage.getItem('cashManageID')
    if (cashRegPay && cashRegPay != '') {
      const postSalePaymentData = DataServices.postSalePaymentData(
        body,
        BEHAVIOUR_TYPE.POST,
        'MainSale'
      )
      await postSalePaymentData
        .then(res => {
          if (res.earnedLoyalty > 0) {
            dispatch(loadEarnedLoyalty(getEarnedLoyalty + res.earnedLoyalty))
          } else {
            dispatch(loadEarnedLoyalty(0))
          }

          //if account sale's payment done
          if (
            getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
            getDecryptID(getCurrentSalesOrderStatusID) == '2'
          ) {
            let customerData = getCustomerSearchData
            if (customerData && !isEmptyObject(customerData)) {
              const toCut = body.PaymentAmount
                ? body.PaymentAmount
                : body.paymentAmount
                ? body.paymentAmount
                : 0
              const cusAccCredit = customerData.accountCredit
                ? customerData.accountCredit
                : 0
              const resValue = cusAccCredit - toCut
              customerData.accountCredit = resValue < 0 ? 0 : resValue
            }
            ApplyCustomerAccountDetails(
              dispatch,
              customerData,
              getStorePaymentTypes,
              getDefaultDecimalPlaces,
              getIsRefundSale,
              getReturnStoreCredit,
              getIsLoyaltyEnabled,
              getIsStoreCreditEnabled
            )
          }

          // if (getDecryptID(getCurrentSalesOrderStatusID) == "1" || getDecryptID(getCurrentSalesOrderStatusID) == "2") {
          //   let customerData = getCustomerSearchData;
          //   const customer = onAccLayBySaleEffects( // this effect only accCredit of customer
          //     customerData,
          //     getAccLaybyCreditAmount,
          //     formAmountToPay,
          //     false,
          //     dispatch,
          //   );
          //   if (customer && !isEmptyObject(customer)) {
          //     customerData = customer;
          //   }
          //   ApplyCustomerAccountDetails(
          //     dispatch,
          //     customerData,
          //     getStorePaymentTypes,
          //     getDefaultDecimalPlaces,
          //     getIsRefundSale,
          //     getReturnStoreCredit,
          //     getIsLoyaltyEnabled,
          //     getIsStoreCreditEnabled,
          //   );
          // }
        })
        .catch(e => {
          notAllowMsgCheck(e)
          // dispatch(loadIsPaymentPanelLoading(false));
          // setIsLoading(false);
        })
    } else {
      message.warn('Unable to pay ...')
    }
  }

  const onFolderCloseClick = () => {
    dispatch(loadIsFolderActive(false))
    dispatch(loadActiveFolderData([]))
    dispatch(loadQuicKeyDetails(getMainQuickKeysDetails))
    dispatch(loadQuickKeyCount({ rows: 5, columns: 5 }))
  }

  function handleQuickMenuClick (e) {
     dispatch(loadIsFolderActive(false))
 
    let quicKKeyLayoutID = e.quicKKeyLayoutID
    if (quicKKeyLayoutID) {
      quicKKeyLayoutID = getDecryptID(quicKKeyLayoutID)
      const updatedQuickKeys =
        getAllQuickKeysDetails &&
        getAllQuickKeysDetails.quickKeyLayouts.map(x => ({
          ...x,
          currentlyActive: getDecryptID(x.quicKKeyLayoutID) == quicKKeyLayoutID
        }))
      const updatedQuickKeysDetails =
        getAllQuickKeysDetails &&
        getAllQuickKeysDetails.quickKeyLayoutDetails.filter(
          x => getDecryptID(x.quickKeyLayoutID) == quicKKeyLayoutID
        )
      // let updatedAllDetails = getAllQuickKeysDetails
      // updatedAllDetails.quickKeyLayouts = updatedQuickKeys
      //  dispatch(loadAllQuicKeyDetails(updatedAllDetails));
      setAllLayoutsData(updatedQuickKeys.filter(x => x.isActive))
      dispatch(loadMainQuicKeyDetails(updatedQuickKeysDetails))
      dispatch(loadQuicKeyDetails(updatedQuickKeysDetails))
    }
  }

  function changeShowQuickKeys (val) {
    // setShowQuickKeys(val ? true : false);
    dispatch(loadShowQuickKey(val ? true : false))
  }
  function checkRenderQuickKeys () {
    let result = true
    if (!screen_width) {
      result = true
    } else if (screen_width < LANDSCAPE_QUICK_KEY) {
      result = false
    }
    return result
  }

  return getAllowMakeSales ? (
    <div className='gx-sale-screen pos-screen' key={compReload}>
      <InfoToPrint
        role={'AutoPrintSale'}
        data={getDataToPrint}
        outletName={outletName}
        registerName={registerName}
        allowPrintNote={getPrintNoteReceipt}
        allowDiscountShow={getShowDiscounts}
        allowPrint={getPrintReceipt}
      />
      {checkIsWeb().exist && isScreenOpened ? (
        <>
          <Row className='text-center'>
            <Col lg={24} md={24} sm={24} xs={24}>
              <h1>Sell Screen is already open in another tab</h1>
              <h3>
                Please close the other tab to access the screen or use this
                screen over there.
              </h3>
            </Col>

            <Col lg={24} md={24} sm={24} xs={24} className='mt-5'>
              <Button
                type='primary'
                // block
                onClick={e => {
                  localStorage.setItem('cartOpened', 0)
                  window.removeEventListener('beforeunload', handleCartUnload)
                  window.location.reload()
                }}
              >
                Force Open
              </Button>
              <h4 className='mt-3'>
                <strong style={{ color: '#ed1e1ec2' }}>Precaution: </strong>
                It is strictly suggested to open only one sale cart.
              </h4>
            </Col>
          </Row>
        </>
      ) : (
        <>
          {checkIsWeb().exist && isMobile && (
            <a
              onClick={() => {
                dispatch(loadShowHeaderFooter(!showHeaderFooter))
                if (!showHeaderFooter && screen_width <= TAB_SIZE) {
                  dispatch(toggleCollapsedSideNav(!navCollapsed))
                }
              }}
              class={`float-sell-screen ${showHeaderFooter ? 'go-back' : ''}`}
              style={{
                marginTop: isInFreeTrial ? '-130px' : '',
                zIndex: !showHeaderFooter ? '9999' : '0'
              }}
            >
              {showHeaderFooter ? (
                <UpOutlined
                  style={{ marginTop: 27, fontSize: 24 }}
                  className='my-float-sell-screen'
                  // style={{ transform: 'rotate(90deg)' }}
                />
              ) : (
                <DownOutlined
                  className='my-float-sell-screen'
                  // style={{ transform: 'rotate(90deg)' }}
                />
              )}
            </a>
          )}
          {notificationBar && (
            <div
              class='headerBar'
              style={{
                background: notificationBGColor
                  ? notificationBGColor
                  : '#1abc9c'
              }}
            >
              <h1 style={{ color: 'white', marginTop: 3 }}>
                {notificationHead}
              </h1>
            </div>
          )}
          {getSelectedOutlet && getSelectedReg ? (
            <>
              <RegOpenDialog />
              <PromoPrompt getCurr={getCurrData} />
              {getIsSalePanelActive ? (
                <Spin
                  tip={<IntlMessages id='common.resource.loading' />}
                  spinning={isMainLoading || isDetailLoading}
                  size='large'
                >
                  <SaleProgressModal />
                  <ParkedSaleModal />

                  <Row>
                    <Col xl={14} lg={12} md={10} sm={10} xs={24}>
                      <div className='category-dflex'>
                         
                        {getEnableAllPOSLayouts &&
                        getAllLayoutsData.length > 0 ? (
                          <div className='category-menu theme-scroll theme-scroll-SmallTrack'>
                            <ul>
                              {getAllLayoutsData.map((e, index) => {
                                if (e.isActive) {
                                  let imageURL = !StringIsNullOrEmpty(e.url)
                                    ? e.url
                                    : DefaultImage
                                  let activeClassName = e.currentlyActive
                                    ? 'Active-category-menu'
                                    : ''
                                  let bgColor = !StringIsNullOrEmpty(
                                    e.colorCode
                                  )
                                    ? e.colorCode
                                    : '#a5b51e'
                                  return (
                                    <li onClick={() => handleQuickMenuClick(e)}>
                                      <a
                                        className={activeClassName}
                                        style={{ backgroundColor: bgColor }}
                                      >
                                        {' '}
                                        <span>
                                          <img alt='' src={imageURL} />
                                        </span>
                                        {e.layoutName}
                                      </a>
                                    </li>
                                  )
                                }
                              })}
                            </ul>
                          </div>
                        ) : (
                          ''
                        )}

                        {/* <li><a href='#'> <span><img alt='' src={Hotpot} /></span> Grill Items</a></li>
                      <li><a href='#'> <span><img alt='' src={Hamburger} /></span> Burgers</a></li>
                      <li><a href='#' className='Active-category-menu'> <span><img alt='' src={Hamburgerone} /></span> Sandwiches</a></li>
                      <li><a href='#'> <span><img alt='' src={Bowl} /></span> Soups</a></li>
                      <li><a href='#'> <span><img alt='' src={Cakefive} /></span> Muffines </a></li>
                      <li><a href='#'> <span><img alt='' src={Drink} /></span> Soft Drinks</a></li>
                      <li><a href='#'> <span><img alt='' src={Cakethree} /></span> Cakes</a></li>
                      <li><a href='#'> <span><img alt='' src={Pizza2} /></span> Pizza Deliverys</a></li> */}

                        <div
                          className={`product-wrapper div-flow  ${cartMainClass}`}
                        >
                          <SearchProduct screen='SellScreen' />
                          {checkRenderQuickKeys() ? (
                            <>
                              {getConfigSellLayout ? (
                                <>
                                  {getIsFolderActive ? (
                                    <div
                                      className='dk-sale-quick-key-folder-header d-flex align-items-center justify-content-between Park-Sale-controller'
                                      style={{
                                        backgroundColor: getActiveColorCode
                                      }}
                                    >
                                      <div className='QuickKeysFolderHeadingBar'>
                                        <FolderOpenOutlined />
                                        <h2 className='mb-0'>
                                          {' '}
                                          {getActiveFolderData.folderName}{' '}
                                        </h2>
                                      </div>

                                      <Button
                                        className='d-flex align-items-center justify-content-center bck-btn'
                                        type='primary'
                                        onClick={e => {
                                          onFolderCloseClick()
                                        }}
                                        icon={<ArrowLeftOutlined />}
                                      >
                                        Back
                                      </Button>
                                    </div>
                                  ) : (
                                    ''
                                  )}

                                  <div className='dk-sale-shortcuts Pos-Products theme-scroll theme-scroll-SmallTrack'>
                                    <div className=' dk-flex-sale'>
                                      {/* dk-mobile-hide */}
                                      {getQuickKeysDetails.length > 0 ? (
                                        <QuickKeys outlet={getSelectedOutlet} />
                                      ) : (
                                        <DefaultQuickKeyLayout />
                                      )}
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <DefaultQuickKeyLayout />
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <QuickKeysModal
                                selOutlet={getSelectedOutlet}
                                show={showQuickKeys}
                                setShow={changeShowQuickKeys}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col xl={10} lg={12} md={14} sm={14} xs={24}>
                      <div className={`Cart-wrapper div-flow ${cartMainClass}`}>
                        {!getReduxIsRegisterOpen ? (
                          <div className='set-inner-container'>
                            <OpeningFloat
                              isCashManage={true}
                              isCreateDisable={!getAllowMakeSales} //getIsDisableCreate
                            />
                          </div>
                        ) : (
                          <RightPanel
                            getCurrData={getCurrData}
                            discountPerm={getApplyDiscountPerm}
                            getStoreCreditPerm={getStoreCreditPerm}
                            returnStoreCredit={getReturnStoreCredit}
                            allowMakeSales={getAllowMakeSales}
                            availableUsers={availableUsers}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </Spin>
              ) : (
                <>
                  {!singleScreenForCart && (
                    <PaymentPanel
                      getCurrData={getCurrData}
                      returnStoreCredit={getReturnStoreCredit}
                      getLaySalePerm={getLaySalePerm}
                      getAccountSalePerm={getAccountSalePerm}
                      outletName={outletName}
                      registerName={registerName}
                      outletid={getSelectedOutlet}
                      allowPrint={getPrintReceipt}
                      allowPrintNote={getPrintNoteReceipt}
                      allowDiscountShow={getShowDiscounts}
                      allowNextUser={getSelectNextUser}
                    />
                  )}
                </>
              )}
              <PaymentStatusModal />
              {singleScreenForCart && (
                <SingleScreenCartModal
                  getCurrData={getCurrData}
                  returnStoreCredit={getReturnStoreCredit}
                  getLaySalePerm={getLaySalePerm}
                  getAccountSalePerm={getAccountSalePerm}
                  outletName={outletName}
                  registerName={registerName}
                  outletid={getSelectedOutlet}
                  allowPrint={getPrintReceipt}
                  allowPrintNote={getPrintNoteReceipt}
                  allowDiscountShow={getShowDiscounts}
                  allowNextUser={getSelectNextUser}
                />
              )}
            </>
          ) : (
            <>
              <Row justify='center'>
                <Col>
                  <h1>Kindly Select Register and Outlet</h1>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default MainSale
